/**
 * Where the back end is, from the build environment.
 *
 * Written by `scripts/write-web-env.sh` out of the CloudFormation outputs, so
 * these never get typed by hand into a file someone then commits. Missing
 * values throw at start-up rather than producing a page that half works.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `${name} is not set. Run scripts/write-web-env.sh after deploying.`);
  }
  return value.replace(/\/$/, '');
}

export const config = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL),
  userPoolId: required('VITE_USER_POOL_ID', import.meta.env.VITE_USER_POOL_ID),
  clientId: required('VITE_USER_POOL_CLIENT_ID',
                     import.meta.env.VITE_USER_POOL_CLIENT_ID),
  region: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
};

export const cognitoAuthority =
  `https://cognito-idp.${config.region}.amazonaws.com/${config.userPoolId}`;
